<template>
    <FormModal :model="model" :init="init" modal-id="shipping" :beforeSaving="beforeSaving" @save="saved" @destroy="$emit('destroy', $event)" item-id="id" @shown="shown" :is-enabled-view-mode="false">
        <template>
            <div :key="key" class="d-flex">
                <ItemBadges :model="model" class="mb-1" />
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <div v-for="value in error">
                <input-error :errors="value" />
            </div>

            <template>
                <template v-if="auth_level >= '200'">
                    <div class="p-3 my-3 bg-light">
                        <strong>ユーザーID</strong>
                    </div>

                    <SelectUserInGroup
                        v-model="order_user_id"
                        :me="true"
                        />
                </template>

                <div class="p-3 my-3 bg-light">
                    <strong>プラットフォーム注文情報</strong>
                </div>

                <div class="my-3">
                    <strong>検索（{{ data_orders.length }}件）</strong>
                </div>

                <b-input-group class="">
                    <b-form-input v-model="order_query" placeholder="商品名、購入者、注文番号" @keydown.enter.native="fetchOrders"></b-form-input>
                    <b-form-select v-model="order_provider" class="order-provider">
                         <b-form-select-option value="">All</b-form-select-option>
                         <b-form-select-option value="ebay">eBay</b-form-select-option>
<!--
                         <b-form-select-option value="amazon">Amazon US</b-form-select-option>
                         <b-form-select-option value="amazon_au">Amazon AU</b-form-select-option>
                         <b-form-select-option value="amazon_ca">Amazon CA</b-form-select-option>
-->
                    </b-form-select>
                    <b-input-group-append>
                    </b-input-group-append>
                    <template #append>
                        <b-button
                            variant="secondary"
                            @click="fetchOrders"
                            >
                            検索
                        </b-button>
                    </template>
                </b-input-group>

                <b-table small :fields="[ '選択', '日付', '商品名', '受取人', ]" :items="data_orders" hover v-if="data_orders.length">
                    <template #cell(選択)="data">
                        <div class="text-nowrap">
{{ data.item.ogp }}
                            <template v-if="!inSelectedOrders(data.item)">
                                <b-link @click="onSelectOrder(data.item)">個別</b-link>
                                /
                                <b-link @click="onSelectOrder(data.item, true)">連続</b-link>
                            </template>

                            <template v-if="inSelectedOrders(data.item)">
                                <b-link class="text-danger" @click="onDeselectOrder(data.item)">解除</b-link>
                            </template>
                        </div>
                    </template>

                    <template #cell(日付)="data">
                        <small>#{{ data.item.order_id }}</small><br>
                        {{ data.item.ordered_at | BaseDatetimeFormatter }}
                    </template>

                    <template #cell(商品名)="data">
                        <small>#{{ data.item.sku }}</small><br>
                        {{ data.item.title }}<br>

                        <span v-if="data.item['cost_price']">商品代:{{ data.item['cost_price']['value'] + data.item['cost_price']['currencyID'] }}</span>
                        <span v-if="data.item['cost_shipping']">+ 送料:{{ data.item['cost_shipping']['value'] + data.item['cost_shipping']['currencyID'] }}</span>
<!--
                        <span v-if="data.item['cost_handling']">+ 手数料:{{ data.item['cost_handling']['value'] + data.item['cost_handling']['currencyID'] }}</span>
                        <span v-if="data.item['cost_total']">= {{ data.item['cost_total']['value'] + data.item['cost_total']['currencyID'] }}</span><br>
-->
                    </template>

                    <template #cell(受取人)="data">
                        {{ data.item.address.Name }}
                        ({{ data.item.buyer_id }})
                    </template>
                </b-table>

                <div class="my-3 data_orders_selected_title">
                    <strong>選択済({{ (data.data_orders_selected || []).length }}件)</strong>
                </div>

                <div class="mb-3" v-if="(data.data_orders_selected || []).length === 0">
                    選択されたデータはありません。
                </div>

                <div v-if="(data.data_orders_selected || []).length">
                    <b-table small :fields="[ '解除', '日付', '商品名', '受取人', ]" :items="data.data_orders_selected" hover>
                        <template #cell(解除)="data">
                            <div class="text-nowrap">
{{ data.item.ogp     }}
                                <a class="text-danger" @click="onDeselectOrder(data.item)">解除</a>
                            </div>
                        </template>

                        <template #cell(日付)="data">
                            <small>#{{ data.item.order_id }}</small><br>
                            {{ data.item.ordered_at | BaseDatetimeFormatter }}
                        </template>

                        <template #cell(商品名)="data">
                            <small>#{{ data.item.sku }}</small><br>
                            {{ data.item.title }}<br>

                            <span v-if="data.item['cost_price']">商品代:{{ data.item['cost_price']['value'] + data.item['cost_price']['currencyID'] }}</span>
                            <span v-if="data.item['cost_shipping']">+ 送料:{{ data.item['cost_shipping']['value'] + data.item['cost_shipping']['currencyID'] }}</span>
<!--
                            <span v-if="data.item['cost_handling']">+ 手数料:{{ data.item['cost_handling']['value'] + data.item['cost_handling']['currencyID'] }}</span>
                            <span v-if="data.item['cost_total']">= {{ data.item['cost_total']['value'] + data.item['cost_total']['currencyID'] }}</span><br>
-->
                        </template>

                        <template #cell(受取人)="data">
                            {{ data.item.address.Name }}
                            (<b-link @click="fetchOrdersByBuyerId(data.item.buyer_id)">{{ data.item.buyer_id }}</b-link>)
                        </template>
                    </b-table>
                    <p>
                        ※検索結果から同じ購入者を選択すると同梱になります。
                    </p>
                </div>

                <div class="p-3 my-3 bg-light">
                    <strong>住所情報</strong>
                </div>

                <b-row>
                    <b-col>
                        <AddressSearch
                            :prefixes="[ 'from', ]"
                            @select="onSelectAddress"
                            simple
                            />

                        <b-table-simple stacked borderless small>
                            <AddressContent
                                v-model="data"
                                :prefixes="[ 'from_', ]"
                                :fields="address_fields('from')"
                                />
                        </b-table-simple>
                    </b-col>
                    <b-col class="bg-light">
                        <AddressSearch
                            :prefixes="[ 'to', ]"
                            @select="onSelectAddress"
                            simple
                            />

                        <b-table-simple stacked borderless small>
                            <AddressContent
                                v-model="data"
                                :prefixes="[ 'to_', ]"
                                :fields="address_fields('to')"
                                />
                        </b-table-simple>
                    </b-col>
                    <b-col>
                        <div>
                            <b-button
                                variant="outline-secondary"
                                @click="copyAddress('to', 'importer')"
                                class="float-right"
                                >
                                受取人をコピー
                            </b-button>
                            <AddressSearch
                                :prefixes="[ 'importer', ]"
                                @select="onSelectAddress"
                                simple
                                />
                        </div>

                        <b-table-simple stacked borderless small>
                            <AddressContent
                                v-model="data"
                                :prefixes="[ 'importer_', ]"
                                :fields="address_fields('importer')"
                                />
                        </b-table-simple>
                    </b-col>
                </b-row>

                <div class="p-3 my-3 bg-light">
                    <strong>申告商品情報</strong>
                </div>

                <div>
                    <strong>通貨</strong>
                    <SelectCurrencyId
                        v-model="data.item_currency"
                        />
                </div>

                <ItemContent
                    v-model="data.items"
                    :show-rate-link="false"
                    :currency="data.item_currency"
                    cast-price="float"
                    @onChangeCurrency="onChangeCurrency"
                    class="mb-5"
                    />

                <BoxContent
                    v-model="data.boxes"
                    :fields="[ 'fetch', ]"
                    />

                <div class="mt-3 mb-5">
                    <div>
                        <strong>内容物概要(en)</strong>
                        <a class="float-right" @click="copyBoxDescription">申告商品情報1行目をコピー</a>
                    </div>
                    <b-form-input
                        v-model="data.box_description"
                        type="text"
                        placeholder=""
                        >
                    </b-form-input>
                    <div class="text-right" v-if="data.box_description">
                        {{ data.box_description.length }}文字
                    </div>
                </div>

                <CourierContent
                    v-model="data.courier"

                    :from="trim_address(data, 'from')"
                    :to="trim_address(data, 'to')"
                    :importer="trim_address(data, 'importer')"
                    :boxes="data.boxes"
                    :items="data.items"
                    :currency="data.item_currency"
                    />

<!--
                <InvoiceContent
                    v-model="data.invoice"
                    :signature_default="data.from_representative"
                    />
-->

<!--
                <VatContent
                    v-model="data.vat"
                    :from_country="data.from_country"
                    :to_country="data.to_country"
                    :fields="[ 'fetch', ]"
                    />
-->
<!--
                <CourierSupplement
                    v-model="data.supplement"
                    />
-->

<!--
                <div v-show="data.courier && data.courier.shipping_courier_plan.courier && !($store.state.app.data.cannot_attach_insurance || [ null, ]).includes(data.courier.shipping_courier_plan.courier)">
                    <InsuranceContent
                    v-model="data.insurance"
                    :items="data.items"
                    :currency="data.item_currency"
                    cast-price="float"
                    :fields="[ 'fetch', ]"
                    />
                </div>
-->

            </template>




            <br>
            <br>
            <br>
            <br>
            <br>
            <br>
            <br>












<!--
            <ShippingTable
                ref="table"
                :mode="mode"
                :key="mode"
                />
-->

        </template>
    </FormModal>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'
import AddressSearch from '@/components/AddressSearch.vue'
import AddressContent from '@/components/AddressContent.vue'
import BoxContent from '@/components/BoxContent.vue'
import ItemContent from '@/components/ItemContent.vue'
import InsuranceContent from '@/components/InsuranceContent.vue'
import VatContent from '@/components/VatContent.vue'
import InvoiceContent from '@/components/InvoiceContent.vue'
import CourierContent from '@/components/CourierContent.vue'
import CourierSupplement from '@/components/CourierSupplement.vue'
//import LogTable from '@/components/LogTable.vue'
//import ShippingTable from '@/components/ShippingTable.vue'
import SelectCurrencyId from '@/components/SelectCurrencyId.vue'
import SelectUserInGroup from '@/components/SelectUserInGroup.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        AddressSearch,
        AddressContent,
        BoxContent,
        ItemContent,
        InsuranceContent,
        VatContent,
        InvoiceContent,
        CourierContent,
        CourierSupplement,
//        LogTable,
//        ShippingTable,
        SelectCurrencyId,
        SelectUserInGroup,
        InputError,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            key: 0,

            data: {
            },

            order_user_id: null,
            order_query: '',
            order_provider: '',
            order_type: 'word',
            data_orders: [],
//            data_orders_selected_currency: 'USD',
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'auth_id',
            'auth_level',
            'trim_address',
            'trans',
            'shipping_default',
            'dimensional_weight',
            'create_shipping',
            'filter4address',
        ]),
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
        this.shown()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        async saved (data, response) {
            const request_body = JSON.parse(response.config.data)

            switch (request_body.courier.shipping_courier_plan.courier) {
                case 'ecms':
                    Vue.prototype.download(response)

                    await this.$utils.modalAlert(
                        this,
                        'ECMS用データをダウンロードしました',
                        'ECMSサイトでアップロードして見積・登録をしてください。データを修正する場合、入力フォームの内容を変更し、もう一度「保存」ボタンを押してください。特に問題がない場合は、入力フォームの右上の「✕」を押して閉じてください。Tuskeyにデータが反映されるのは月末になります。'
                    )
                    return
                    break
                default:
                    break
            }
            if (this.data.data_orders_selected.length) {
//                await this.$utils.modalAlert(
//                    this,
//                    'eBay出荷通知を登録しました',
//                    'eBayのAPIの不具合などにより出荷通知の登録されない場合があります。必ずご自身でeBay上で出荷通知が完了していることを確認ください。',
//                    {}
//                )

                const result = await this.$utils.modalConfirm(
                    this,
                    'eBay出荷通知を登録しますか？',
                    'eBayのAPIの不具合などにより出荷通知の登録されない場合があります。必ずご自身でeBay上で出荷通知が完了していることを確認ください。',
                    {
                        okVariant: 'primary',
                        okTitle: '登録する',
                        cancelTitle: '登録しない',
                    }
                )
                if (result) {
console.log(data.data.id)
                    this.$store
                        .dispatch('shipping/ship_orders', {
                            shipping_id: data.data.id,
                            data_orders_selected: this.data.data_orders_selected,
                        })
                        .then((response) => {
console.log(response.data)
                            this.$utils.set(this, { courier_plans: response.data, })
                        })
                        .catch((error) => {
                            this.$emit('select', null, null, null)
                        })
                }
            }

            this.$emit('save', data)
        },
        beforeSaving (model) {

//            if (!model.insurance) {
//                const result = this.$utils.modalConfirm(
//                    this,
//                    'Tuskey保険登録の確認',
//                    'aaaaaaaaaaa',
//                    {
//                        okTitle: '保険加入しない',
//                        okVariant: 'outline-secondary',
//                        cancelTitle: '戻る',
//                        cancelVariant: 'outline-secondary',
//                    }
//                )
//                if (result) {
//                    return false
//                }
//            }

            model.user_id = this.order_user_id
            switch (this.data.courier.shipping_courier_plan.courier) {
                case 'ecms':
                    model.KEEP_MODAL_OPEN = 1
                    break
                default:
                    model.KEEP_MODAL_OPEN = 0
                    break
            }

            return this.$utils.set(model, this.data)
//            let data = {}
//
//            switch (this.mode) {
//                case 'update':
//                case 'create':
//                    this.$utils.set(data, {
//                        items: this.$refs.table.getData(),
//                    })
//                    break
//            }
//
//            return Object.assign(model, data)
        },
        fetchOrders (provider_type) {
            this.$utils.empty(this.data_orders)
            this.$store
                .dispatch('shipping/fetch_orders', {
                    order_user_id: this.order_user_id,
                    order_provider: this.order_provider,
                    order_type: this.order_type,
                    order_query: this.order_query,
                    order_shipped: '0',
                })
                .then((response) => {
                    this.data_orders = response.data
                    for (let i = 0; i < this.data_orders.length; i++) {
//                        this.$store
//                            .dispatch('app/ogp', 'https://www.ebay.com/itm/201411279025')
//                            .then((ogp) => {
//console.log(ogp)
//                            })
////                        this.$utils.set(this.data_orders[i], {
////                            ogp: {
////                                hoge: 1,
////                            },
////                        })
                    }
                })
                .catch((error) => {
                })
        },
        fetchOrdersByBuyerId (buyer_id) {
            this.order_query = buyer_id
            this.fetchOrders()
        },
        onSelectAddress ($event, prefix) {
            let options = {}
            options[prefix] = JSON.parse(JSON.stringify($event))
console.log(options)
            let shipping = this.create_shipping(options)
            this.$utils.set(this.data, shipping)
            this.$forceUpdate()
        },
        async onDeselectOrder (item) {
            for (let i = 0; i < this.data.data_orders_selected.length; i++) {
                if (this.inSelectedOrders(item, i)) {
                    this.data.data_orders_selected.splice(i, 1)
                    this.parseSelectedOrders()
                    break
                }
            }
//            this.$utils.empty(this.data_orders)
//
//            document.querySelector('#shipping.modal > .modal-dialog > .modal-content > .modal-body').scrollTop = 0
        },
        async onSelectOrder (item, bulk = false) {
            if (this.inSelectedOrders(item)) {
                return
            }

            if (!bulk) {
//                this.$utils.empty(this.data.data_orders_selected)
            }
            this.data.data_orders_selected.unshift(this.$utils.copy(item))

            this.parseSelectedOrders()

            if (!bulk) {
                document.querySelector('.data_orders_selected_title').scrollIntoView({ behavior: 'smooth', })
            }

            this.$store
                .dispatch('shipping/fetch_fulfillment_order', {
                    order_user_id: this.order_user_id,
                    order_provider: this.data.data_orders_selected[0].provider_type,
                    order_id: this.data.data_orders_selected[0].order_id,
                })
                .then((response) => {
                    switch (response.data.provider_type) {
                        case 'ebay':
                            console.log(response.data)
                            const taxIdentifier = response.data.values.buyer.taxIdentifier
                            console.log(taxIdentifier)
                            break
                    }
                })
        },
        inSelectedOrders (item, specific_index = null) {
            for (let i = 0; i < this.data.data_orders_selected.length; i++) {
                if (specific_index !== null) {
                    if (specific_index !== i) {
                        continue
                    }
                }
                if (item.provider_type === this.data.data_orders_selected[i].provider_type
                    && item.order_id === this.data.data_orders_selected[i].order_id
                ) {
                    return true
                }
            }
            return false
        },
        async parseSelectedOrders () {
            if (this.data.data_orders_selected.length === 0) {
                return
            }

            let item_first = this.data.data_orders_selected[0]

            if (this.data.data_orders_selected.length >= 2) {
                if (item_first.provider_type !== this.data.data_orders_selected[1].provider_type
                    || item_first.buyer_id !== this.data.data_orders_selected[1].buyer_id
                ) {
                    this.data.data_orders_selected.splice(1, this.data.data_orders_selected.length - 1)
alert(
`
別の購入者を選択されたため、登録内容の一部がリセットされました。
`)
                }
            }

            // to
            let shipping_to = this.filter4address(item_first)
            shipping_to = this.$utils.addPrefixProperty(shipping_to, 'to_')
            this.$utils.set(this.data, shipping_to)

            // importer
            this.copyAddress('to', 'importer')

            // items
            let items = []
            for (let i = 0; i < this.data.data_orders_selected.length; i++) {
                items.push({
                    product: this.data.data_orders_selected[i].title,
                    price: this.data.data_orders_selected[i].cost_price.value,
                    currency: this.data.data_orders_selected[i].cost_price.currencyID,
                })
                if (i === 0) {
                    this.data.item_currency = items[i].currency
                }
            }
            this.$utils.set(this.data, {
                items: items,
            })

            this.$forceUpdate()

//alert(
//`
//《住所情報》
//受取人と輸入者を設定しました。
//
//《申告商品情報》
//内容を設定しました。（合計${items.length}件）
//`)
//1行設定しました。（${price_exchanged.from} 1 = JPY ${price_exchanged.rate}）
//※三菱ＵＦＪ銀行為替相場一覧表で為替レートが間違いのないことを確認してください。
        },
        copyAddress (prefix_from, prefix_to) {
            Object.keys(this.data)
                .filter((v, i) => {
                    return v.indexOf(prefix_from + '_') === 0
                })
                .forEach((v, i) => {
                    const key = v.replace(new RegExp('^'+prefix_from+'_'), prefix_to+'_')

                    let replace_with = {}
                    replace_with[key] = this.data[v]
                    this.$utils.set(
                        this.data,
                        replace_with
                    )
                })
        },
        onChangeCurrency (value) {
            this.data.item_currency = value
        },
        copyBoxDescription () {
            if (this.data.items.length === 0) {
                return
            }
            this.data.box_description = this.data.items[0].product
        },
        shown () {
console.log('shown---------------------------')
            this.setDefaultValue()
        },
        setDefaultValue () {
            this.order_user_id = this.auth_id
            this.order_query = ''
            this.order_provider = ''
            this.order_type = 'word'
            this.data_orders.splice(0)
//            this.data_orders_selected_currency = 'USD'

console.log('setDefaultValue---------------------------')
console.log(this.shipping_default)
            this.$utils.set(this.data, this.shipping_default)
        },
        address_fields (type) {
            switch (type) {
                case 'from':
                    return {
                        representative: true,
                        company: false,
                        line1: true,
                        line2: false,
                        city: true,
                        state: true,
                        zip: true,
                        country: true,
                        tel: true,
                        email: true,
                        tax_id: false,
                        vat_id: false,
                        eori: false,
                    }
                case 'to':
                case 'importer':
                    return {
                        representative: true,
                        company: false,
                        line1: true,
                        line2: false,
                        city: true,
                        state: true,
                        zip: true,
                        country: true,
                        tel: true,
                        email: false,
                        tax_id: false,
                        vat_id: false,
                        eori: false,
                    }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
.shipping-address-th {
    width:0.1%;
    white-space: nowrap;
}
</style>

